const countryList = [
  { value: "South Africa", text: "South Africa" },
  { value: "Bangladesh", text: "Bangladesh" },
  { value: "Belgium", text: "Belgium" },
  { value: "Burkina Faso", text: "Burkina Faso" },
  { value: "Bulgaria", text: "Bulgaria" },
  { value: "Bosnia and Herzegovina", text: "Bosnia and Herzegovina" },
  { value: "Barbados", text: "Barbados" },
  { value: "Wallis and Futuna", text: "Wallis and Futuna" },
  { value: "Saint Barthelemy", text: "Saint Barthelemy" },
  { value: "Bermuda", text: "Bermuda" },
  { value: "Brunei", text: "Brunei" },
  { value: "Bolivia", text: "Bolivia" },
  { value: "Bahrain", text: "Bahrain" },
  { value: "Burundi", text: "Burundi" },
  { value: "Benin", text: "Benin" },
  { value: "Bhutan", text: "Bhutan" },
  { value: "Jamaica", text: "Jamaica" },
  { value: "Bouvet Island", text: "Bouvet Island" },
  { value: "Botswana", text: "Botswana" },
  { value: "Samoa", text: "Samoa" },
  {
    value: "Bonaire, Saint Eustatius and Saba ",
    text: "Bonaire, Saint Eustatius and Saba ",
  },
  { value: "Brazil", text: "Brazil" },
  { value: "Bahamas", text: "Bahamas" },
  { value: "Jersey", text: "Jersey" },
  { value: "Belarus", text: "Belarus" },
  { value: "Belize", text: "Belize" },
  { value: "Russia", text: "Russia" },
  { value: "Rwanda", text: "Rwanda" },
  { value: "Serbia", text: "Serbia" },
  { value: "East Timor", text: "East Timor" },
  { value: "Reunion", text: "Reunion" },
  { value: "Turkmenistan", text: "Turkmenistan" },
  { value: "Tajikistan", text: "Tajikistan" },
  { value: "Romania", text: "Romania" },
  { value: "Tokelau", text: "Tokelau" },
  { value: "Guinea-Bissau", text: "Guinea-Bissau" },
  { value: "Guam", text: "Guam" },
  { value: "Guatemala", text: "Guatemala" },
  {
    value: "South Georgia and the South Sandwich Islands",
    text: "South Georgia and the South Sandwich Islands",
  },
  { value: "Greece", text: "Greece" },
  { value: "Equatorial Guinea", text: "Equatorial Guinea" },
  { value: "Guadeloupe", text: "Guadeloupe" },
  { value: "Japan", text: "Japan" },
  { value: "Guyana", text: "Guyana" },
  { value: "Guernsey", text: "Guernsey" },
  { value: "French Guiana", text: "French Guiana" },
  { value: "Georgia", text: "Georgia" },
  { value: "Grenada", text: "Grenada" },
  { value: "United Kingdom", text: "United Kingdom" },
  { value: "Gabon", text: "Gabon" },
  { value: "El Salvador", text: "El Salvador" },
  { value: "Guinea", text: "Guinea" },
  { value: "Gambia", text: "Gambia" },
  { value: "Greenland", text: "Greenland" },
  { value: "Gibraltar", text: "Gibraltar" },
  { value: "Ghana", text: "Ghana" },
  { value: "Oman", text: "Oman" },
  { value: "Tunisia", text: "Tunisia" },
  { value: "Jordan", text: "Jordan" },
  { value: "Croatia", text: "Croatia" },
  { value: "Haiti", text: "Haiti" },
  { value: "Hungary", text: "Hungary" },
  { value: "Hong Kong", text: "Hong Kong" },
  { value: "Honduras", text: "Honduras" },
  {
    value: "Heard Island and McDonald Islands",
    text: "Heard Island and McDonald Islands",
  },
  { value: "Venezuela", text: "Venezuela" },
  { value: "Puerto Rico", text: "Puerto Rico" },
  { value: "Palestinian Territory", text: "Palestinian Territory" },
  { value: "Palau", text: "Palau" },
  { value: "Portugal", text: "Portugal" },
  { value: "Svalbard and Jan Mayen", text: "Svalbard and Jan Mayen" },
  { value: "Paraguay", text: "Paraguay" },
  { value: "Iraq", text: "Iraq" },
  { value: "Panama", text: "Panama" },
  { value: "French Polynesia", text: "French Polynesia" },
  { value: "Papua New Guinea", text: "Papua New Guinea" },
  { value: "Peru", text: "Peru" },
  { value: "Pakistan", text: "Pakistan" },
  { value: "Philippines", text: "Philippines" },
  { value: "Pitcairn", text: "Pitcairn" },
  { value: "Poland", text: "Poland" },
  { value: "Saint Pierre and Miquelon", text: "Saint Pierre and Miquelon" },
  { value: "Zambia", text: "Zambia" },
  { value: "Western Sahara", text: "Western Sahara" },
  { value: "Estonia", text: "Estonia" },
  { value: "Egypt", text: "Egypt" },
  { value: "Ecuador", text: "Ecuador" },
  { value: "Italy", text: "Italy" },
  { value: "Vietnam", text: "Vietnam" },
  { value: "Solomon Islands", text: "Solomon Islands" },
  { value: "Ethiopia", text: "Ethiopia" },
  { value: "Somalia", text: "Somalia" },
  { value: "Zimbabwe", text: "Zimbabwe" },
  { value: "Saudi Arabia", text: "Saudi Arabia" },
  { value: "Spain", text: "Spain" },
  { value: "Eritrea", text: "Eritrea" },
  { value: "Montenegro", text: "Montenegro" },
  { value: "Moldova", text: "Moldova" },
  { value: "Madagascar", text: "Madagascar" },
  { value: "Saint Martin", text: "Saint Martin" },
  { value: "Morocco", text: "Morocco" },
  { value: "Monaco", text: "Monaco" },
  { value: "Uzbekistan", text: "Uzbekistan" },
  { value: "Myanmar", text: "Myanmar" },
  { value: "Mali", text: "Mali" },
  { value: "Macao", text: "Macao" },
  { value: "Mongolia", text: "Mongolia" },
  { value: "Marshall Islands", text: "Marshall Islands" },
  { value: "Macedonia", text: "Macedonia" },
  { value: "Mauritius", text: "Mauritius" },
  { value: "Malta", text: "Malta" },
  { value: "Malawi", text: "Malawi" },
  { value: "Maldives", text: "Maldives" },
  { value: "Martinique", text: "Martinique" },
  { value: "Northern Mariana Islands", text: "Northern Mariana Islands" },
  { value: "Montserrat", text: "Montserrat" },
  { value: "Mauritania", text: "Mauritania" },
  { value: "Isle of Man", text: "Isle of Man" },
  { value: "Uganda", text: "Uganda" },
  { value: "Tanzania", text: "Tanzania" },
  { value: "Malaysia", text: "Malaysia" },
  { value: "Mexico", text: "Mexico" },
  { value: "Israel", text: "Israel" },
  { value: "France", text: "France" },
  {
    value: "British Indian Ocean Territory",
    text: "British Indian Ocean Territory",
  },
  { value: "Saint Helena", text: "Saint Helena" },
  { value: "Finland", text: "Finland" },
  { value: "Fiji", text: "Fiji" },
  { value: "Falkland Islands", text: "Falkland Islands" },
  { value: "Micronesia", text: "Micronesia" },
  { value: "Faroe Islands", text: "Faroe Islands" },
  { value: "Nicaragua", text: "Nicaragua" },
  { value: "Netherlands", text: "Netherlands" },
  { value: "Norway", text: "Norway" },
  { value: "Namibia", text: "Namibia" },
  { value: "Vanuatu", text: "Vanuatu" },
  { value: "New Caledonia", text: "New Caledonia" },
  { value: "Niger", text: "Niger" },
  { value: "Norfolk Island", text: "Norfolk Island" },
  { value: "Nigeria", text: "Nigeria" },
  { value: "New Zealand", text: "New Zealand" },
  { value: "Nepal", text: "Nepal" },
  { value: "Nauru", text: "Nauru" },
  { value: "Niue", text: "Niue" },
  { value: "Cook Islands", text: "Cook Islands" },
  { value: "Kosovo", text: "Kosovo" },
  { value: "Ivory Coast", text: "Ivory Coast" },
  { value: "Switzerland", text: "Switzerland" },
  { value: "Colombia", text: "Colombia" },
  { value: "China", text: "China" },
  { value: "Cameroon", text: "Cameroon" },
  { value: "Chile", text: "Chile" },
  { value: "Cocos Islands", text: "Cocos Islands" },
  { value: "Canada", text: "Canada" },
  { value: "Republic of the Congo", text: "Republic of the Congo" },
  { value: "Central African Republic", text: "Central African Republic" },
  {
    value: "Democratic Republic of the Congo",
    text: "Democratic Republic of the Congo",
  },
  { value: "Czech Republic", text: "Czech Republic" },
  { value: "Cyprus", text: "Cyprus" },
  { value: "Christmas Island", text: "Christmas Island" },
  { value: "Costa Rica", text: "Costa Rica" },
  { value: "Curacao", text: "Curacao" },
  { value: "Cape Verde", text: "Cape Verde" },
  { value: "Cuba", text: "Cuba" },
  { value: "Swaziland", text: "Swaziland" },
  { value: "Syria", text: "Syria" },
  { value: "Sint Maarten", text: "Sint Maarten" },
  { value: "Kyrgyzstan", text: "Kyrgyzstan" },
  { value: "Kenya", text: "Kenya" },
  { value: "South Sudan", text: "South Sudan" },
  { value: "Suriname", text: "Suriname" },
  { value: "Kiribati", text: "Kiribati" },
  { value: "Cambodia", text: "Cambodia" },
  { value: "Saint Kitts and Nevis", text: "Saint Kitts and Nevis" },
  { value: "Comoros", text: "Comoros" },
  { value: "Sao Tome and Principe", text: "Sao Tome and Principe" },
  { value: "Slovakia", text: "Slovakia" },
  { value: "South Korea", text: "South Korea" },
  { value: "Slovenia", text: "Slovenia" },
  { value: "North Korea", text: "North Korea" },
  { value: "Kuwait", text: "Kuwait" },
  { value: "Senegal", text: "Senegal" },
  { value: "San Marino", text: "San Marino" },
  { value: "Sierra Leone", text: "Sierra Leone" },
  { value: "Seychelles", text: "Seychelles" },
  { value: "Kazakhstan", text: "Kazakhstan" },
  { value: "Cayman Islands", text: "Cayman Islands" },
  { value: "Singapore", text: "Singapore" },
  { value: "Sweden", text: "Sweden" },
  { value: "Sudan", text: "Sudan" },
  { value: "Dominican Republic", text: "Dominican Republic" },
  { value: "Dominica", text: "Dominica" },
  { value: "Djibouti", text: "Djibouti" },
  { value: "Denmark", text: "Denmark" },
  { value: "British Virgin Islands", text: "British Virgin Islands" },
  { value: "Germany", text: "Germany" },
  { value: "Yemen", text: "Yemen" },
  { value: "Algeria", text: "Algeria" },
  { value: "United States", text: "United States" },
  { value: "Uruguay", text: "Uruguay" },
  { value: "Mayotte", text: "Mayotte" },
  {
    value: "United States Minor Outlying Islands",
    text: "United States Minor Outlying Islands",
  },
  { value: "Lebanon", text: "Lebanon" },
  { value: "Saint Lucia", text: "Saint Lucia" },
  { value: "Laos", text: "Laos" },
  { value: "Tuvalu", text: "Tuvalu" },
  { value: "Taiwan", text: "Taiwan" },
  { value: "Trinidad and Tobago", text: "Trinidad and Tobago" },
  { value: "Turkey", text: "Turkey" },
  { value: "Sri Lanka", text: "Sri Lanka" },
  { value: "Liechtenstein", text: "Liechtenstein" },
  { value: "Latvia", text: "Latvia" },
  { value: "Tonga", text: "Tonga" },
  { value: "Lithuania", text: "Lithuania" },
  { value: "Luxembourg", text: "Luxembourg" },
  { value: "Liberia", text: "Liberia" },
  { value: "Lesotho", text: "Lesotho" },
  { value: "Thailand", text: "Thailand" },
  { value: "French Southern Territories", text: "French Southern Territories" },
  { value: "Togo", text: "Togo" },
  { value: "Chad", text: "Chad" },
  { value: "Turks and Caicos Islands", text: "Turks and Caicos Islands" },
  { value: "Libya", text: "Libya" },
  { value: "Vatican", text: "Vatican" },
  {
    value: "Saint Vincent and the Grenadines",
    text: "Saint Vincent and the Grenadines",
  },
  { value: "United Arab Emirates", text: "United Arab Emirates" },
  { value: "Andorra", text: "Andorra" },
  { value: "Antigua and Barbuda", text: "Antigua and Barbuda" },
  { value: "Afghanistan", text: "Afghanistan" },
  { value: "Anguilla", text: "Anguilla" },
  { value: "U.S. Virgin Islands", text: "U.S. Virgin Islands" },
  { value: "Iceland", text: "Iceland" },
  { value: "Iran", text: "Iran" },
  { value: "Armenia", text: "Armenia" },
  { value: "Albania", text: "Albania" },
  { value: "Angola", text: "Angola" },
  { value: "Antarctica", text: "Antarctica" },
  { value: "American Samoa", text: "American Samoa" },
  { value: "Argentina", text: "Argentina" },
  { value: "Australia", text: "Australia" },
  { value: "Austria", text: "Austria" },
  { value: "Aruba", text: "Aruba" },
  { value: "India", text: "India" },
  { value: "Aland Islands", text: "Aland Islands" },
  { value: "Azerbaijan", text: "Azerbaijan" },
  { value: "Ireland", text: "Ireland" },
  { value: "Indonesia", text: "Indonesia" },
  { value: "Ukraine", text: "Ukraine" },
  { value: "Qatar", text: "Qatar" },
  { value: "Mozambique", text: "Mozambique" },
];
  // { value: "+27", text: "+27 (ZA)" },
  // { value: "+267", text: "+267 (BW)" },
  // { value: "+266", text: "+266 (LS)" },
  // { value: "+264", text: "+264 (NA)" },
  // { value: "+268", text: "+268 (SZ)" },
  // { value: "+260", text: "+260 (ZM)" },
  // { value: "+263", text: "+263 (ZW)" },
const areaCodes = [
{ value: "+93", text: "+93 (AF)"  },
{ value: "+355", text: "+355 (AL)"  },
{ value: "+213", text: "+213 (DZ)"  },
{ value: "+1-684", text: "+1-684 (AS)"  },
{ value: "+376", text: "+376 (AD)"  },
{ value: "+244", text: "+244 (AO)"  },
{ value: "+1-264", text: "+1-264 (AI)"  },
{ value: "+672", text: "+672 (AQ)"  },
{ value: "+1-268", text: "+1-268 (AG)"  },
{ value: "+54", text: "+54 (AR)"  },
{ value: "+374", text: "+374 (AM)"  },
{ value: "+297", text: "+297 (AW)"  },
{ value: "+61", text: "+61 (AU)"  },
{ value: "+43", text: "+43 (AT)"  },
{ value: "+994", text: "+994 (AZ)"  },
{ value: "+1-242", text: "+1-242 (BS)"  },
{ value: "+973", text: "+973 (BH)"  },
{ value: "+880", text: "+880 (BD)"  },
{ value: "+1-246", text: "+1-246 (BB)"  },
{ value: "+375", text: "+375 (BY)"  },
{ value: "+32", text: "+32 (BE)"  },
{ value: "+501", text: "+501 (BZ)"  },
{ value: "+229", text: "+229 (BJ)"  },
{ value: "+1-441", text: "+1-441 (BM)"  },
{ value: "+975", text: "+975 (BT)"  },
{ value: "+591", text: "+591 (BO)"  },
{ value: "+387", text: "+387 (BA)"  },
{ value: "+267", text: "+267 (BW)"  },
{ value: "+55", text: "+55 (BR)"  },
{ value: "+246", text: "+246 (IO)"  },
{ value: "+1-284", text: "+1-284 (VG)"  },
{ value: "+673", text: "+673 (BN)"  },
{ value: "+359", text: "+359 (BG)"  },
{ value: "+226", text: "+226 (BF)"  },
{ value: "+257", text: "+257 (BI)"  },
{ value: "+855", text: "+855 (KH)"  },
{ value: "+237", text: "+237 (CM)"  },
{ value: "+1", text: "+1 (CA)"  },
{ value: "+238", text: "+238 (CV)"  },
{ value: "+1-345", text: "+1-345 (KY)"  },
{ value: "+236", text: "+236 (CF)"  },
{ value: "+235", text: "+235 (TD)"  },
{ value: "+56", text: "+56 (CL)"  },
{ value: "+86", text: "+86 (CN)"  },
{ value: "+61", text: "+61 (CX)"  },
{ value: "+61", text: "+61 (CC)"  },
{ value: "+57", text: "+57 (CO)"  },
{ value: "+269", text: "+269 (KM)"  },
{ value: "+682", text: "+682 (CK)"  },
{ value: "+506", text: "+506 (CR)"  },
{ value: "+385", text: "+385 (HR)"  },
{ value: "+53", text: "+53 (CU)"  },
{ value: "+599", text: "+599 (CW)"  },
{ value: "+357", text: "+357 (CY)"  },
{ value: "+420", text: "+420 (CZ)"  },
{ value: "+243", text: "+243 (CD)"  },
{ value: "+45", text: "+45 (DK)"  },
{ value: "+253", text: "+253 (DJ)"  },
{ value: "+1-767", text: "+1-767 (DM)"  },
{ value: "+1-809, 1-829, 1-849", text: "+1-809, 1-829, 1-849 (DO)"  },
{ value: "+670", text: "+670 (TL)"  },
{ value: "+593", text: "+593 (EC)"  },
{ value: "+20", text: "+20 (EG)"  },
{ value: "+503", text: "+503 (SV)"  },
{ value: "+240", text: "+240 (GQ)"  },
{ value: "+291", text: "+291 (ER)"  },
{ value: "+372", text: "+372 (EE)"  },
{ value: "+251", text: "+251 (ET)"  },
{ value: "+500", text: "+500 (FK)"  },
{ value: "+298", text: "+298 (FO)"  },
{ value: "+679", text: "+679 (FJ)"  },
{ value: "+358", text: "+358 (FI)"  },
{ value: "+33", text: "+33 (FR)"  },
{ value: "+689", text: "+689 (PF)"  },
{ value: "+241", text: "+241 (GA)"  },
{ value: "+220", text: "+220 (GM)"  },
{ value: "+995", text: "+995 (GE)"  },
{ value: "+49", text: "+49 (DE)"  },
{ value: "+233", text: "+233 (GH)"  },
{ value: "+350", text: "+350 (GI)"  },
{ value: "+30", text: "+30 (GR)"  },
{ value: "+299", text: "+299 (GL)"  },
{ value: "+1-473", text: "+1-473 (GD)"  },
{ value: "+1-671", text: "+1-671 (GU)"  },
{ value: "+502", text: "+502 (GT)"  },
{ value: "+44-1481", text: "+44-1481 (GG)"  },
{ value: "+224", text: "+224 (GN)"  },
{ value: "+245", text: "+245 (GW)"  },
{ value: "+592", text: "+592 (GY)"  },
{ value: "+509", text: "+509 (HT)"  },
{ value: "+504", text: "+504 (HN)"  },
{ value: "+852", text: "+852 (HK)"  },
{ value: "+36", text: "+36 (HU)"  },
{ value: "+354", text: "+354 (IS)"  },
{ value: "+91", text: "+91 (IN)"  },
{ value: "+62", text: "+62 (ID)"  },
{ value: "+98", text: "+98 (IR)"  },
{ value: "+964", text: "+964 (IQ)"  },
{ value: "+353", text: "+353 (IE)"  },
{ value: "+44-1624", text: "+44-1624 (IM)"  },
{ value: "+972", text: "+972 (IL)"  },
{ value: "+39", text: "+39 (IT)"  },
{ value: "+225", text: "+225 (CI)"  },
{ value: "+1-876", text: "+1-876 (JM)"  },
{ value: "+81", text: "+81 (JP)"  },
{ value: "+44-1534", text: "+44-1534 (JE)"  },
{ value: "+962", text: "+962 (JO)"  },
{ value: "+7", text: "+7 (KZ)"  },
{ value: "+254", text: "+254 (KE)"  },
{ value: "+686", text: "+686 (KI)"  },
{ value: "+383", text: "+383 (XK)"  },
{ value: "+965", text: "+965 (KW)"  },
{ value: "+996", text: "+996 (KG)"  },
{ value: "+856", text: "+856 (LA)"  },
{ value: "+371", text: "+371 (LV)"  },
{ value: "+961", text: "+961 (LB)"  },
{ value: "+266", text: "+266 (LS)"  },
{ value: "+231", text: "+231 (LR)"  },
{ value: "+218", text: "+218 (LY)"  },
{ value: "+423", text: "+423 (LI)"  },
{ value: "+370", text: "+370 (LT)"  },
{ value: "+352", text: "+352 (LU)"  },
{ value: "+853", text: "+853 (MO)"  },
{ value: "+389", text: "+389 (MK)"  },
{ value: "+261", text: "+261 (MG)"  },
{ value: "+265", text: "+265 (MW)"  },
{ value: "+60", text: "+60 (MY)"  },
{ value: "+960", text: "+960 (MV)"  },
{ value: "+223", text: "+223 (ML)"  },
{ value: "+356", text: "+356 (MT)"  },
{ value: "+692", text: "+692 (MH)"  },
{ value: "+222", text: "+222 (MR)"  },
{ value: "+230", text: "+230 (MU)"  },
{ value: "+262", text: "+262 (YT)"  },
{ value: "+52", text: "+52 (MX)"  },
{ value: "+691", text: "+691 (FM)"  },
{ value: "+373", text: "+373 (MD)"  },
{ value: "+377", text: "+377 (MC)"  },
{ value: "+976", text: "+976 (MN)"  },
{ value: "+382", text: "+382 (ME)"  },
{ value: "+1-664", text: "+1-664 (MS)"  },
{ value: "+212", text: "+212 (MA)"  },
{ value: "+258", text: "+258 (MZ)"  },
{ value: "+95", text: "+95 (MM)"  },
{ value: "+264", text: "+264 (NA)"  },
{ value: "+674", text: "+674 (NR)"  },
{ value: "+977", text: "+977 (NP)"  },
{ value: "+31", text: "+31 (NL)"  },
{ value: "+599", text: "+599 (AN)"  },
{ value: "+687", text: "+687 (NC)"  },
{ value: "+64", text: "+64 (NZ)"  },
{ value: "+505", text: "+505 (NI)"  },
{ value: "+227", text: "+227 (NE)"  },
{ value: "+234", text: "+234 (NG)"  },
{ value: "+683", text: "+683 (NU)"  },
{ value: "+850", text: "+850 (KP)"  },
{ value: "+1-670", text: "+1-670 (MP)"  },
{ value: "+47", text: "+47 (NO)"  },
{ value: "+968", text: "+968 (OM)"  },
{ value: "+92", text: "+92 (PK)"  },
{ value: "+680", text: "+680 (PW)"  },
{ value: "+970", text: "+970 (PS)"  },
{ value: "+507", text: "+507 (PA)"  },
{ value: "+675", text: "+675 (PG)"  },
{ value: "+595", text: "+595 (PY)"  },
{ value: "+51", text: "+51 (PE)"  },
{ value: "+63", text: "+63 (PH)"  },
{ value: "+64", text: "+64 (PN)"  },
{ value: "+48", text: "+48 (PL)"  },
{ value: "+351", text: "+351 (PT)"  },
{ value: "+1-787, 1-939", text: "+1-787, 1-939 (PR)"  },
{ value: "+974", text: "+974 (QA)"  },
{ value: "+242", text: "+242 (CG)"  },
{ value: "+262", text: "+262 (RE)"  },
{ value: "+40", text: "+40 (RO)"  },
{ value: "+7", text: "+7 (RU)"  },
{ value: "+250", text: "+250 (RW)"  },
{ value: "+590", text: "+590 (BL)"  },
{ value: "+290", text: "+290 (SH)"  },
{ value: "+1-869", text: "+1-869 (KN)"  },
{ value: "+1-758", text: "+1-758 (LC)"  },
{ value: "+590", text: "+590 (MF)"  },
{ value: "+508", text: "+508 (PM)"  },
{ value: "+1-784", text: "+1-784 (VC)"  },
{ value: "+685", text: "+685 (WS)"  },
{ value: "+378", text: "+378 (SM)"  },
{ value: "+239", text: "+239 (ST)"  },
{ value: "+966", text: "+966 (SA)"  },
{ value: "+221", text: "+221 (SN)"  },
{ value: "+381", text: "+381 (RS)"  },
{ value: "+248", text: "+248 (SC)"  },
{ value: "+232", text: "+232 (SL)"  },
{ value: "+65", text: "+65 (SG)"  },
{ value: "+1-721", text: "+1-721 (SX)"  },
{ value: "+421", text: "+421 (SK)"  },
{ value: "+386", text: "+386 (SI)"  },
{ value: "+677", text: "+677 (SB)"  },
{ value: "+252", text: "+252 (SO)"  },
{ value: "+27", text: "+27 (ZA)"  },
{ value: "+82", text: "+82 (KR)"  },
{ value: "+211", text: "+211 (SS)"  },
{ value: "+34", text: "+34 (ES)"  },
{ value: "+94", text: "+94 (LK)"  },
{ value: "+249", text: "+249 (SD)"  },
{ value: "+597", text: "+597 (SR)"  },
{ value: "+47", text: "+47 (SJ)"  },
{ value: "+268", text: "+268 (SZ)"  },
{ value: "+46", text: "+46 (SE)"  },
{ value: "+41", text: "+41 (CH)"  },
{ value: "+963", text: "+963 (SY)"  },
{ value: "+886", text: "+886 (TW)"  },
{ value: "+992", text: "+992 (TJ)"  },
{ value: "+255", text: "+255 (TZ)"  },
{ value: "+66", text: "+66 (TH)"  },
{ value: "+228", text: "+228 (TG)"  },
{ value: "+690", text: "+690 (TK)"  },
{ value: "+676", text: "+676 (TO)"  },
{ value: "+1-868", text: "+1-868 (TT)"  },
{ value: "+216", text: "+216 (TN)"  },
{ value: "+90", text: "+90 (TR)"  },
{ value: "+993", text: "+993 (TM)"  },
{ value: "+1-649", text: "+1-649 (TC)"  },
{ value: "+688", text: "+688 (TV)"  },
{ value: "+1-340", text: "+1-340 (VI)"  },
{ value: "+256", text: "+256 (UG)"  },
{ value: "+380", text: "+380 (UA)"  },
{ value: "+971", text: "+971 (AE)"  },
{ value: "+44", text: "+44 (GB)"  },
{ value: "+1", text: "+1 (US)"  },
{ value: "+598", text: "+598 (UY)"  },
{ value: "+998", text: "+998 (UZ)"  },
{ value: "+678", text: "+678 (VU)"  },
{ value: "+379", text: "+379 (VA)"  },
{ value: "+58", text: "+58 (VE)"  },
{ value: "+84", text: "+84 (VN)"  },
{ value: "+681", text: "+681 (WF)"  },
{ value: "+212", text: "+212 (EH)"  },
{ value: "+967", text: "+967 (YE)"  },
{ value: "+260", text: "+260 (ZM)"  },
{ value: "+263", text: "+263 (ZW)"  },

];

const addressOption = [
  { value: "L", text: "Local" },
  { value: "F", text: "Foreign" },
];

const provinces = [
  { value: "Eastern Cape", text: "Eastern Cape" },
  { value: "Free State", text: "Free State" },
  { value: "Gauteng", text: "Gauteng" },
  { value: "KwaZulu Natal", text: "KwaZulu Natal" },
  { value: "Limpopo", text: "Limpopo" },
  { value: "Mpumalanga", text: "Mpumalanga" },
  { value: "Northern Cape", text: "Northern Cape" },
  { value: "North West", text: "North West" },
  { value: "Western Cape", text: "Western Cape" },
];

export default { countryList, areaCodes, addressOption, provinces };
